module.exports = __webpack_public_path__ + "static/media/office.b7caa9f0.jfif";